import { useQuery } from 'react-query'
import { useInsuranceQuery } from '../../CarDetailTables/tables/queries'
import { Clipboard } from '../_shared/Buttons/Clipboard'
import { SecondaryButton } from '../_shared/Buttons/SecondaryButton'
import { Emphasize } from '../_shared/Emphasize'
import { Loader } from '../_shared/Loader'
import { TinyBox } from '../_shared/TinyBox'
import { getInsuranceInformation } from '../../../../../api/newApi'
import { useChosenCompany, useUser } from '../../../../../context/UserProvider'

export function ReportDamage({ id }: { id: string }) {
  const company = useChosenCompany()
  const user = useUser()
  console.log(id)
  console.log(company.id)
  console.log(user.user.id)
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['insurance-modal', id],
    queryFn: () =>
      getInsuranceInformation({
        accountNo: id,
        companyId: company?.id,
        contactId: user?.user.id,
      }),
  })

  if (isLoading) {
    return (
      <div className="w-full min-h-[120px] min-w-[200px] flex items-center justify-center">
        <Loader />
      </div>
    )
  }

  if (isError) {
    return (
      <div className="w-full min-h-[120px] min-w-[200px] flex items-center justify-center">
        <p className="text-red-500">Noe gikk galt...</p>
      </div>
    )
  }

  const findClaim = data?.phoneNumbers?.find((phone) => phone.type === 'claim')
  return (
    <div className="flex flex-col items-start gap-2 relative p-2">
      <h3 className=" text-xl font-semibold">Slik melder du skade</h3>
      <div className="flex flex-col leading-7">
        <p className="text-oldoffGrey">
          Din forsikringspartner som sist var kjent for oss er{' '}
          <Emphasize>{data?.code ? data?.code : 'Ukjent'}</Emphasize>.
        </p>
        {data?.homepage && (
          <p>
            Gå til{' '}
            <a className="text-old-primaryLight hover:underline cursor-pointer" href={data.homepage}>
              {data?.homepage}
            </a>{' '}
            for å registrere skaden, eller ring kundeservice.
          </p>
        )}
      </div>
      <div className="flex flex-col gap-4 py-4 w-full">
        {findClaim && findClaim?.number && (
          <TinyBox title={`Telefonnummer Kundeservice`} actionComponent={<Clipboard text={findClaim?.number} />}>
            <p className="text-old-primaryLight">{findClaim?.number}</p>
          </TinyBox>
        )}
      </div>
      {data?.homepage && <SecondaryButton linkUrl={data?.homepage}>Gå til {data?.homepage}</SecondaryButton>}
    </div>
  )
}
